import { render, staticRenderFns } from "./Replicated.vue?vue&type=template&id=1e380b2e&"
import script from "./Replicated.vue?vue&type=script&lang=js&"
export * from "./Replicated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e380b2e')) {
      api.createRecord('1e380b2e', component.options)
    } else {
      api.reload('1e380b2e', component.options)
    }
    module.hot.accept("./Replicated.vue?vue&type=template&id=1e380b2e&", function () {
      api.rerender('1e380b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Replicated.vue"
export default component.exports